module.exports = __webpack_public_path__ + "img/email.6db637f6.svg";